import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ArrowUpRightIcon, CircleXMarkFilledIcon } from "~@/icons";

const Error: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="block block--has-mb-21">
        <span className="icon icon--has-default-size">
          <CircleXMarkFilledIcon />
        </span>
      </div>
      <div className="block block--has-mb-10">
        <h2 className="onboarding__subtitle">
          {t("onboarding.payment-method.error.title")}
        </h2>
      </div>
      <div className="block block--has-mb-20">
        <span className="onboarding__description">
          {t("onboarding.payment-method.error.description")}
        </span>
      </div>
      <div className="block">
        <button
          className="button button--h-48 button--fill-black-0"
          type="button"
        >
          <span>{t("action.try-again")}</span>
          <span className="icon">
            <ArrowUpRightIcon />
          </span>
        </button>
      </div>
    </>
  );
};

export default Error;
